import { Inject, Injectable, Optional } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslationsService } from '@pages/translations/translations.service';
import { TRANSLATION_DEBOUNCE_TIME } from '@shared/tokens';
import {
  LoadAndSetTranslations,
  SetIsTranslationLoaded,
  SetTranslations,
  ActionTypes as TranslationActionTypes
} from '@store/translation/translation.actions';
import { of } from 'rxjs';
import { catchError, debounceTime, map, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class TranslationsEffects {
  loadAndSetTranslations$ = createEffect(() =>
    this.actions$.pipe(
      ofType<LoadAndSetTranslations>(TranslationActionTypes.LOAD_AND_SET_TRANSLATIONS),
      debounceTime(this.translationDebounceTime),
      switchMap(({ payload }) => {
        const { lang, eventId } = payload;

        return this.translationsService.loadAndMergeTranslations(lang, eventId).pipe(
          map((translations: { [key: string]: string }) => {
            return new SetTranslations({
              language: lang,
              list: translations
            });
          }),
          catchError(() => of(new SetTranslations(null)))
        );
      })
    )
  );

  setIsTranslationLoaded$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SetTranslations>(TranslationActionTypes.SET_TRANSLATIONS),
      debounceTime(this.translationDebounceTime),
      tap(({ payload }) => this.translationsService.setTranslationsIntoTranslateService(payload)),
      switchMap(() => of(new SetIsTranslationLoaded(true)))
    )
  );

  constructor(
    @Optional() @Inject(TRANSLATION_DEBOUNCE_TIME) private translationDebounceTime: number,
    private actions$: Actions,
    private translationsService: TranslationsService
  ) {}
}
